import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
} from "react-bootstrap";
import { BiTrash } from "react-icons/bi";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getBatchClassworkPerformanceResult,
  editClassworkPerformance,
} from "../../actions/ClassworkPerformance.action";
import { months, years } from "../../constants/MonthsAndYears";
import styles from "./EditClassworkPerformanceForm.module.css";

const EditClassworkPerformanceForm = ({
  grades,
  getBatchClassworkPerformanceResult,
  editClassworkPerformance,
  extra,
}) => {
  const [grade, setGrade] = useState("");
  const [batch, setBatch] = useState("");
  const [shift, setShift] = useState("");
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [loading, setLoading] = useState(false);
  const [month, setMonth] = useState(new Date().getMonth() + 1);

  const [students, setStudents] = useState(null);

  const navigate = useNavigate();

  const selectHandeler = async () => {
    const list = await getBatchClassworkPerformanceResult(year, month, batch);
    if (!list || list.length === 0) {
      setStudents([]);
      return;
    }
    setStudents(
      list.map((l) => ({
        id: l.classworkPerformances.length > 0 ? l.classworkPerformances[0].id : 0,
        studentId: l.id,
        uid: l.uid,
        name: l.name,
        phone: l.phone,
        gained: l.classworkPerformances.length > 0 ? l.classworkPerformances[0].gained : 0,
        total: l.classworkPerformances.length > 0 ? l.classworkPerformances[0].total : 0,
      }))
    );
  };

  const submitHandeler = async () => {
    setLoading(true);

    let check = await editClassworkPerformance(month, year, students);
    if (check === true) {
      setLoading(false);
      navigate("/admin/classwork-performance/view");
    } else {
      setLoading(false);
    }
  };

  const deleteHandeler = (id) => {
    setStudents([...students.filter((st) => st.id !== id)]);
  };
  return (
    <Container>
      <Card bg="white" text="dark" className={`crd shadow`}>
        <Card.Body>
          <Row>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="grade" className="d-block">
                  Class
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setBatch("");
                  setShift("");
                  setGrade(e.target.value);
                }}
              >
                <option value={""}>Select Class</option>
                {grades &&
                  grades.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            {grade !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="shift" className="d-block">
                    Shift
                  </label>
                </div>
                <Form.Select
                  onChange={(e) => {
                    setBatch("");
                    setShift(e.target.value);
                  }}
                >
                  <option value={""}>Select Shift</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .shifts.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" && shift !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="batch" className="d-block">
                    Batch
                  </label>
                </div>
                <Form.Select onChange={(e) => setBatch(e.target.value)}>
                  <option value={""}>Select Batch</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .batches.filter((bt) => bt.shiftId === parseInt(shift))
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" && shift !== "" && batch !== "" ? (
              <Col
                md={3}
                className="d-flex jsutify-content-end align-items-end py-3"
              >
                <Button
                  onClick={selectHandeler}
                  variant="primary"
                  type="submit"
                  className="btn_primary"
                >
                  Select
                </Button>
              </Col>
            ) : (
              <></>
            )}
          </Row>
          <Row>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="month" className="d-block">
                  Month
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setMonth(parseInt(e.target.value));
                }}
                id="month"
                name="month"
                value={month}
              >
                {months.map((item, i) => (
                  <option key={i} value={`${i + 1}`}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="year" className="d-block">
                  Year
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setYear(e.target.value);
                }}
                id="year"
                name="year"
                value={year}
              >
                {years.map((item, i) => (
                  <option key={i} value={`${item}`}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {students ? (
        <Card bg="white" text="dark" className={`crd shadow mt-4`}>
          <Card.Body>
            <h1 className="fs-4 fw-normal py-3">
              Fill the student marks{" "}
              <b>
                {extra && extra?.month && extra?.year
                  ? `for ${months[extra.month - 1]} ${extra.year}`
                  : ""}
              </b>
            </h1>
            <Row>
              <Col
                md={1}
                className="d-flex align-items-center justify-content-center"
              >
                <span className="d-block fw-bold">Roll</span>
              </Col>
              <Col md={4} className="d-flex align-items-center ">
                <span className="d-block fw-bold">Name</span>
              </Col>
              <Col md={3} className="d-flex align-items-center ">
                <span className="d-block fw-bold">Total Mark</span>
              </Col>
              <Col md={3} className="d-flex align-items-center ">
                <span className="d-block fw-bold">Gained Mark</span>
              </Col>

              <Col md={1} className="d-flex align-items-center ">
                <span className="d-block fw-bold">Delete</span>
              </Col>
            </Row>
            <hr />
            {students
              .sort(function (a, b) {
                if (a.uid < b.uid) return -1;
                if (a.uid > b.uid) return 1;
                return 0;
              })
              .map((student) => (
                <Row key={student.id}>
                  <Col
                    md={1}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <span className="d-block">
                      <span className="fw-bold">{student.uid}</span>
                    </span>
                  </Col>
                  <Col md={4} className="d-flex align-items-center">
                    <span className="d-block">
                      <span className="fw-bold">{student.name}</span>
                    </span>
                  </Col>

                  <Col md={3}>
                    <InputGroup className=" d-flex flex-column">
                      <Form.Control
                        placeholder="Total mark..."
                        name="total"
                        type="number"
                        required
                        className={`${styles.input} w-100`}
                        value={
                          students.filter((s) => s.id === student.id)[0].total
                        }
                        step={0.01}
                        onChange={(e) =>
                          setStudents([
                            ...students.map((std) =>
                              student.id === std.id
                                ? {
                                    ...std,
                                    total: parseFloat(e.target.value),
                                  }
                                : std
                            ),
                          ])
                        }
                      />
                    </InputGroup>
                  </Col>
                  <Col md={3}>
                    <InputGroup className=" d-flex flex-column">
                      <Form.Control
                        placeholder="Gained mark..."
                        name="gained"
                        type="number"
                        required
                        className={`${styles.input} w-100`}
                        value={
                          students.filter((s) => s.id === student.id)[0].gained
                        }
                        step={0.01}
                        onChange={(e) =>
                          setStudents([
                            ...students.map((std) =>
                              student.id === std.id
                                ? {
                                    ...std,
                                    gained: parseFloat(e.target.value),
                                  }
                                : std
                            ),
                          ])
                        }
                      />
                    </InputGroup>
                  </Col>

                  <Col md={1} className="d-flex align-items-center">
                    <span
                      className={`text-danger fs-4  ${styles.del}`}
                      onClick={() => deleteHandeler(student.id)}
                    >
                      <BiTrash />
                    </span>
                  </Col>
                  <hr className="mt-3 mx-auto" style={{ width: "93%" }} />
                </Row>
              ))}
            <Row>
              <Col md={6}></Col>
            </Row>
            <Button
              onClick={submitHandeler}
              variant="primary"
              className="btn_primary"
              disabled={loading}
            >
              {loading ? "Loading..." : "Submit"}
            </Button>
          </Card.Body>
        </Card>
      ) : (
        <></>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  extra: state.classworkPerformance.extra,
});
export default connect(mapStateToProps, {
  getBatchClassworkPerformanceResult,
  editClassworkPerformance,
})(EditClassworkPerformanceForm);
